import FeaturedExperiences from '../FeaturedExperiences/FeaturedExperiences';

import LandingPageInfo from './components/landingpaginfo';

import dynamic from 'next/dynamic';
const LazyGuides = dynamic(() => import('../../utils/LazyLoadGuides'));
import Cities from '../FeaturedCities/OurCities';
import TestimonialsContainer from '../../shared-components/testimonials/testimonialsContainer';
import { Suspense } from 'react';
import OurGuides from '../Guides/guides';
import { TESTIMONIALS } from '../../api/testimonials';
const LazyLoadTestimonials = dynamic(
  () => import('../../utils/LazyLoadTestimonials')
);
interface IProps {
  featuredExp: any;
  citydropdown: any;
  HomePage: {
    homePage?: {
      cities?: any[];
      citiesTotal?: {
        aggregate: {
          totalCount: number;
        };
      };
    };
  };
}
const LandingPage = ({ featuredExp, citydropdown, HomePage }: IProps) => {
  const cities = HomePage?.homePage?.cities || [];
  const citiesTotal =
    HomePage?.homePage?.citiesTotal?.aggregate?.totalCount || 0;

  return (
    <div id="landing-page">
      <FeaturedExperiences
        featuredExp={featuredExp || {}}
        citydropdown={citydropdown}
      />

      <Cities
        title="Our Cities"
        subTitle="Local Roots. Real Stories. Authentic Adventures."
        FeaturedCities={cities}
        citiesTotalCount={citiesTotal}
      />
      <LandingPageInfo />
      <div className="w-[90%] lg:w-[85%] 3xl:w-[80%] max-w-[1750px] mx-auto">
        <Suspense>
          <TestimonialsContainer query={TESTIMONIALS} heading="Testimonials" />
          {process.env.NEXT_PUBLIC_MODE === 'LIVE' && (
            <div
              className="elfsight-app-1df5d44e-350f-49b0-83f3-2974a31153c1"
              data-elfsight-app-lazy
            ></div>
          )}
        </Suspense>
      </div>
      <Suspense>
        <OurGuides />
      </Suspense>
    </div>
  );
};

export default LandingPage;
